import React from 'react';

const CurrentSubscription = ({ subscription, onChangePlan, onExtend }) => {
  // expiredDays - это общая длительность подписки
  // daysLeft - это количество оставшихся дней
  const totalDays = subscription.expiredDays;
  const usedDays = totalDays - subscription.daysLeft;
  const remainingPercentage = totalDays > 0 ? (subscription.daysLeft / totalDays) * 100 : 0;
  
  return (
    <div className="mb-8 transform-gpu transition-medium hover:scale-[1.005]">
      <h2 className="text-2xl font-bold mb-5 flex items-center group">
        <div className="w-10 h-10 rounded-lg bg-accent-purple/20 flex items-center justify-center mr-3 transform-gpu group-hover:rotate-12 transition-medium">
          <i className="fas fa-gem text-accent-purple"></i>
        </div>
        Current Subscription
        <div className="ml-3 text-xs py-1 px-2 bg-accent-purple/20 rounded-full text-accent-purple opacity-0 group-hover:opacity-100 transition-medium">
          Active
        </div>
      </h2>
      
      <div className="bg-dark-600 rounded-2xl p-6 mb-6 gradient-border premium-glow transform-gpu hover:-translate-y-1 hover:shadow-lg transition-medium">
        <div className="flex flex-col md:flex-row justify-between md:items-center">
          <div className="mb-4 md:mb-0 group">
            <div className="flex items-center mb-2">
              <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-accent-purple to-accent-blue flex items-center justify-center mr-3 premium-pulse transform-gpu group-hover:rotate-6 transition-medium">
                <i className="fas fa-gem text-sm group-hover:animate-spin transition-medium"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold gradient-text-premium group-hover:animate-pulse-text">{subscription.type} Plan</h3>
                <p className="text-gray-400 text-sm group-hover:text-gray-300 transition-medium">
                  Billed monthly · Renews on {subscription.renewDate}
                </p>
              </div>
            </div>
          </div>
          
          <div className="flex flex-wrap gap-3">
            <button 
              onClick={onChangePlan}
              className="px-4 py-2 bg-dark-500 hover:bg-dark-400 rounded-xl text-sm transition-medium transform-gpu hover:-translate-y-0.5 hover:shadow-md active:translate-y-0 active:shadow-inner flex items-center"
            >
              <i className="fas fa-exchange-alt mr-1.5 group-hover:rotate-90 transition-medium"></i> Change Plan
            </button>
            <button 
              onClick={onExtend}
              className="px-4 py-2 bg-gradient-to-r from-accent-green to-accent-blue hover:opacity-90 rounded-xl text-sm transition-medium transform-gpu hover:-translate-y-0.5 hover:shadow-glow active:translate-y-0 active:shadow-inner flex items-center"
            >
              <i className="fas fa-calendar-plus mr-1.5 group-hover:scale-110 transition-medium"></i> Extend Subscription
            </button>
          </div>
        </div>
        
        <div className="mt-6 pt-6 border-t border-dark-400">
          <div className="flex flex-col md:flex-row md:items-center text-sm mb-4 gap-4">
            <div className="flex items-center group">
              <span className="text-gray-400 mr-2 group-hover:text-white transition-medium">Status:</span>
              <span className="text-accent-green flex items-center">
                {subscription.status}
                <span className="ml-1.5 w-2 h-2 rounded-full bg-accent-green animate-ping-slow"></span>
              </span>
            </div>
            <div className="flex items-center group">
              <span className="text-gray-400 mr-2 group-hover:text-white transition-medium">Price:</span>
              <span className="group-hover:text-accent-purple transition-medium">{subscription.price}</span>
            </div>
            <div className="flex items-center group">
              <span className="text-gray-400 mr-2 group-hover:text-white transition-medium">Subscription ID:</span>
              <span className="group-hover:text-accent-blue transition-medium">{subscription.subscriptionId}</span>
            </div>
          </div>
          
          <div className="mb-4 group">
            <p className="text-sm text-gray-400 mb-2 group-hover:text-white transition-medium">Time remaining:</p>
            <div className="w-full bg-dark-400 rounded-full h-2.5 overflow-hidden">
              <div 
                className="bg-gradient-to-r from-accent-pink to-accent-purple h-2.5 rounded-full transition-all duration-500 ease-out" 
                style={{ width: `${remainingPercentage}%` }}
              ></div>
            </div>
            <div className="flex justify-between text-xs mt-1">
              <span className="group-hover:text-accent-pink transition-medium">{usedDays} days used</span>
              <span className="text-accent-purple group-hover:scale-110 transition-medium">{subscription.daysLeft} days left</span>
              <span className="group-hover:text-accent-blue transition-medium">{totalDays} days total</span>
            </div>
          </div>
          
          <div className="mt-4 text-sm group">
            <p className="mb-2 font-medium group-hover:text-accent-purple transition-medium">{subscription.type} Plan Features:</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
              {subscription.features.map((feature, index) => (
                <div key={index} className="flex items-center group">
                  <i className="fas fa-check text-accent-green mr-2 text-xs group-hover:scale-125 transition-medium"></i>
                  <span className="group-hover:text-white transition-medium">{feature}</span>
                </div>
              ))}
              {subscription.missingFeatures.map((feature, index) => (
                <div key={`missing-${index}`} className="flex items-center text-gray-500 group">
                  <i className="fas fa-times text-accent-red mr-2 text-xs group-hover:scale-125 transition-medium"></i>
                  <span className="group-hover:text-gray-400 transition-medium">{feature}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CurrentSubscription;